import React from 'react';
import PromoPg from 'containers/FrontPg/ImageCarousel/promopg.jsx'
const promocheat = () => {
    return (
      <PromoPg></PromoPg>
    );
};

export default promocheat;


// WEBPACK FOOTER //
// ./src/containers/homePublic/ImageCarousel/promocheat.jsx